import React from "react";

const LeadList = React.lazy(() => import("./LeadList"));
const LeadShow = React.lazy(() => import("./LeadShow"));
const LeadCreate = React.lazy(() => import("./LeadCreate"));

export default {
  list: LeadList,
  show: LeadShow,
  create: LeadCreate,
  recordRepresentation: (record: any) =>
    record?.contact_name || record?.address_line1 || `Lead ${record?.id?.slice(0, 8)}`,
};
